import http from "@/services/http";
import { IModifyRoleParams, IUpdateTransText } from "@/types/summary";

interface ISyncEditRecordParams extends IUpdateTransText {
  isTrans?: boolean;
}

/**
 * 会中同步编辑原文的统一接口
 * @param updatedPara 更新后的段落数据
 * @param editRoleType 编辑类型：'ONE' | 'BATCH'
 */
export const syncEditRecord = async (params: ISyncEditRecordParams) => {
  return http.post("/api/auth/record-server/doc/sync-opt", params);
};


/**
 * 会中同步修改发言人名称
 * @param updatedPara 更新后的段落数据
 * @param editRoleType 编辑类型：'ONE' | 'BATCH'
 */
export const syncModifySpeakerName = async (params: IModifyRoleParams) => {
  return http.post("/api/auth/record-server/doc/opt-role", params);
};

